export default "__VITE_ASSET__lrhG6CiV__"